import { useState } from 'react';

const useDialog = () => {
  const [dialogOpened, setDialogOpened] = useState(false);

  const openDialog = () => {
    setDialogOpened(true);
  };

  const closeDialog = () => {
    setDialogOpened(false);
  };

  return {
    dialogOpened,
    openDialog,
    closeDialog,
  };
};

export default useDialog;
